/**
 * <collection-description> - the clamped collection description with a show more / show less
 * toggle, rendered by blocks/collection-description.liquid.
 *
 * The text ships clamped by CSS (so the products stay near the top even before JS runs) and the
 * toggle ships [hidden]; this element reveals the toggle only when the clamp actually hides
 * content, so short descriptions never grow a pointless button. A ResizeObserver re-checks on
 * width changes - a description that fits at desktop width can overflow at mobile width.
 */
class CollectionDescription extends HTMLElement {
  #observer;

  connectedCallback() {
    this.text = this.querySelector('[data-text]');
    this.toggle = this.querySelector('[data-toggle]');
    if (!this.text || !this.toggle) return;

    this.toggle.addEventListener('click', () => this.#setExpanded(!this.expanded));
    this.#observer = new ResizeObserver(() => this.#update());
    this.#observer.observe(this.text);
    this.#update();
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  get expanded() {
    return this.classList.contains('is-expanded');
  }

  #setExpanded(expanded) {
    this.classList.toggle('is-expanded', expanded);
    this.toggle.setAttribute('aria-expanded', String(expanded));
    this.toggle.textContent = expanded ? this.dataset.labelLess : this.dataset.labelMore;
    if (!expanded) this.#update();
  }

  #update() {
    if (this.expanded) return;
    const overflowing = this.text.scrollHeight > this.text.clientHeight + 1;
    this.toggle.hidden = !overflowing;
  }
}

if (!customElements.get('collection-description')) {
  customElements.define('collection-description', CollectionDescription);
}
